import API from 'app/services/businessTrip/businessTripApi'
import { CountryModel } from 'app/models/timesheet/countryModel'
import { CurrencyModel } from 'app/models/newDelegation/currencyModel'

/**
 * Słowniki krajów i walut dla stawek delegacji.
 *
 * Trzymał je slice `businessTrips`, choć czytał je dokładnie jeden ekran i pobierał
 * bez żadnych parametrów poza firmą — czyli klasyczny przypadek dla react-query.
 */
export const countriesKey = (companyId?: string | null) =>
  ['businessTrip', 'countries', companyId ?? null] as const

export const currenciesKey = (companyId?: string | null) =>
  ['businessTrip', 'currencies', companyId ?? null] as const

export const fetchCountries = async (
  companyId: string,
): Promise<CountryModel[]> => {
  const response = await API.create().getCountries(companyId)
  return response.content.data
}

export const fetchCurrencies = async (
  companyId: string,
): Promise<CurrencyModel[]> => {
  const response = await API.create().getCurrencies(companyId)
  return response.content.data
}
